import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-vendor-products-page',
  templateUrl: './vendor-products-page.component.html',
  styleUrls: ['./vendor-products-page.component.scss']
})
export class VendorProductsPageComponent implements OnInit {

  public links = [
    { title: 'Vendor Pending Transfers', link: '/contentadmin/vendorproducts/vendor-pending-transfers'},
    { title: 'Vendor Completed Transfers', link: '/contentadmin/vendorproducts/vendor-completed-transfers'},
  ];

  public activeLink: any;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    const parsedUrl = this.router.parseUrl(this.router.url);
    this.activeLink = this.links.find(link => link.link === parsedUrl.toString().split('?')[0]);
  }

  gotoTab(link: string): void {
    if (this.activeLink?.link === link) {
      return;
    }
    this.router.navigate([link]);
    this.activeLink = link;
  }

}
